<template>
  <div>
    <v-container class="py-0">
      <transition name="fade" mode="out-in" appear>
        <PageTitle class="d-block d-sm-none">Tenants</PageTitle>
      </transition>

      <transition name="slide-left-fade" mode="out-in" appear>
        <v-tabs
          v-model="tab"
          class="mt-5 mt-sm-1"
          color="tabColor"
          slider-color="tabColor"
          center-active
          background-color="tertiary"
          show-arrows
          height="55"
        >
          <v-tab ripple>
            In arrears
          </v-tab>
          <v-tab ripple>
            Not chased
          </v-tab>
          <v-tab ripple>
            Active
          </v-tab>
          <v-tab ripple>
            Historic
          </v-tab>
          <v-spacer></v-spacer>
          <span class="d-none d-sm-block">
            <PageTitle>Tenants</PageTitle>
          </span>
        </v-tabs>
      </transition>

      <transition name="slide-fade" mode="out-in" appear>
        <div>
          <v-tabs-items v-model="tab" class="pt-2 tertiary">
            <v-tab-item>
              <TenantsInArrearsTable
                :tableData="tenantsArrearsRecords"
                :headers="headersInArrears"
                msg="In arrears"
                subMsg="All"
                :isLoading="loading.arrears"
                @paginate="handlePaginationUpdate"
              />
            </v-tab-item>
            <v-tab-item>
              <TenantsRecordsTable
                :tableData="tenantsNotChasedRecords"
                :headers="headers"
                showTotPayments="true"
                msg="not chased"
                :isHistoric="false"
                :isLoading="loading.notChased"
                @paginate="handlePaginationUpdate"
              />
            </v-tab-item>  
            <v-tab-item>
              <TenantsRecordsTable
                :tableData="tenantsActiveRecords"
                :headers="headers"
                msg="active"
                :isHistoric="false"
                :isLoading="loading.active"
                @paginate="handlePaginationUpdate"
              />
            </v-tab-item>
            <v-tab-item>
              <TenantsRecordsTable
                :tableData="tenantsHistoricRecords"
                :headers="headers"
                msg="historic"
                :isHistoric="true"
                :isLoading="loading.historic"
                @paginate="handlePaginationUpdate"
              />
            </v-tab-item>
          </v-tabs-items>
        </div>
      </transition>
      
      <transition name="slide-fade" mode="out-in" appear>

        <v-row>
          <v-col cols="12">
            <v-expansion-panels multiple class="mt-8">
              <v-expansion-panel>
                <v-expansion-panel-header ripple class="secondary lighten-3 white--text">
                  <div class="d-flex align-center justify-start">
                    <v-icon class="mr-3" color="white">mdi-pencil</v-icon>
                    Edit Tenancy
                  </div>
                  <template v-slot:actions>
                    <v-icon color="white">$expand</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <EditTenancy />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header ripple class="secondary lighten-3 white--text">
                  <div class="d-flex align-center justify-start">
                    <v-icon class="mr-3" color="white">mdi-pencil</v-icon>
                    Edit Tenant
                  </div>
                  <template v-slot:actions>
                    <v-icon color="white">$expand</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <EditTenant />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </transition>

    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TenantsRecordsTable from '../components/Tenants/TenantsRecordsTable.vue'
import TenantsInArrearsTable from '../components/Tenants/TenantsInArrearsTable.vue'
import EditTenancy from '@/components/Edits/EditTenancy.vue'
import EditTenant from '@/components/Edits/EditTenant.vue'
import PageTitle from '@/components/Slots/PageTitle.vue';

export default {
  components: {
    TenantsRecordsTable,
    TenantsInArrearsTable,
    EditTenancy,
    EditTenant,
    PageTitle
  },
  data() {
    return {
      tab: null,
      active: true,
      inArrears: true,
      inArrearsOver: true,
      inArrearsUnder: true,
      notChased: true,
      historic: true,
      search: '',
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'TenantName',
          sortable: false
        },
        { text: 'Address', value: 'TenantAddress', width: '30%', sortable: false },
        { text: 'Balance', value: 'TenantBalance', width: '10%', sortable: false },
        { text: 'Days in Debt', value: 'TenantInDebtDuration', align: 'center', sortable: false },
        { text: 'Debt Date', value: 'TenantIntoDebtDate', sortable: false },
        { text: '', value: 'actions', sortable: false, align: 'end' }
        // { text: 'Support', value: 'Message' },
     ],
      headersInArrears: [
        {
          text: 'Name',
          align: 'left',
          value: 'TenantName',
          sortable: false
        },
        { text: 'Address', value: 'TenantAddress', sortable: false },
        { text: 'Balance', value: 'TenantBalance', sortable: false, width: '15%' },
        { text: 'Rent', value: 'RentAmount', sortable: false, width: '15%' },
        { text: 'Debt', value: 'TenantInDebtDuration', sortable: false, width: '15%' },
        { text: '', value: 'actions', sortable: false, align: 'end' }
      ],
      pagination: {
        active: { page: 1, itemsPerPage: 10 },
        arrears: { page: 1, itemsPerPage: 10 },
        notChased: { page: 1, itemsPerPage: 10 },
        historic: { page: 1, itemsPerPage: 10 }
      },
      loadedTabs: {
        arrears: false,
        notChased: false,
        active: false,
        historic: false
      }
    }
  },
  created() {
    // Only load the first tab on initial load
    this.loadArrearsTenants()
    this.loadedTabs.arrears = true
  },
  watch: {
    tab(newTab) {
      // Load data for the selected tab if not already loaded
      const tabMap = {
        0: 'arrears',
        1: 'notChased',
        2: 'active',
        3: 'historic'
      }
      
      const tabType = tabMap[newTab]
      if (tabType && !this.loadedTabs[tabType]) {
        this.loadTabData(tabType)
        this.loadedTabs[tabType] = true
      }
    }
  },
  computed: {
    ...mapState({
        tenantsNotChasedRecords: state => ({
          Data: state.TenantsRecords.tenantsNotChasedRecords,
          Count: state.TenantsRecords.totalCount.notChased
        }), 
        tenantsArrearsRecords: state => ({
          Data: state.TenantsRecords.tenantsArrearsRecords,
          Count: state.TenantsRecords.totalCount.arrears
        }), 
        tenantsActiveRecords: state => ({
          Data: state.TenantsRecords.tenantsActiveRecords,
          Count: state.TenantsRecords.totalCount.active
        }),
        tenantsArrearsLessThan60Days: state => ({
          Data: state.TenantsRecords.tenantsArrearsLessThan61Days,
          Count: state.TenantsRecords.tenantsArrearsLessThan61Days.length
        }),
        tenantsArrearsOver60Days: state => ({
          Data: state.TenantsRecords.tenantsArrearsOver61Days,
          Count: state.TenantsRecords.tenantsArrearsOver61Days.length
        }),
        tenantsHistoricRecords: state => ({
          Data: state.TenantsRecords.tenantsHistoricRecords,
          Count: state.TenantsRecords.totalCount.historic
        }),
        // Loading states
        loading: state => state.TenantsRecords.loading
    })
  },
  methods: {
    async loadTenantData() {
      await Promise.all([
        this.loadActiveTenants(),
        this.loadArrearsTenants(),
        this.loadNotChasedTenants(),
        this.loadHistoricTenants()
      ])
    },
    async loadTabData(tabType) {
      switch(tabType) {
        case 'active':
          await this.loadActiveTenants()
          break
        case 'arrears':
          await this.loadArrearsTenants()
          break
        case 'notChased':
          await this.loadNotChasedTenants()
          break
        case 'historic':
          await this.loadHistoricTenants()
          break
      }
    },
    async loadActiveTenants(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.active.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.active.itemsPerPage
      await this.$store.dispatch('TenantsRecords/getTenantsActiveRecords', {
        offset,
        limit: this.pagination.active.itemsPerPage,
        forceRefresh: itemsPerPage !== null, // Force refresh when items per page changes
        ...filters
      })
      this.pagination.active.page = page
    },
    async loadArrearsTenants(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.arrears.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.arrears.itemsPerPage
      await this.$store.dispatch('TenantsRecords/getTenantsArrearsRecords', {
        offset,
        limit: this.pagination.arrears.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.arrears.page = page
    },
    async loadNotChasedTenants(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.notChased.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.notChased.itemsPerPage
      await this.$store.dispatch('TenantsRecords/getTenantsNotChasedRecords', {
        offset,
        limit: this.pagination.notChased.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.notChased.page = page
    },
    async loadHistoricTenants(page = 1, itemsPerPage = null, filters = {}) {
      if (itemsPerPage !== null) {
        this.pagination.historic.itemsPerPage = itemsPerPage
      }
      const offset = (page - 1) * this.pagination.historic.itemsPerPage
      await this.$store.dispatch('TenantsRecords/getTenantsHistoricRecords', {
        offset,
        limit: this.pagination.historic.itemsPerPage,
        forceRefresh: itemsPerPage !== null,
        ...filters
      })
      this.pagination.historic.page = page
    },
    handlePaginationUpdate(type, page, itemsPerPage, filters = {}) {
      // Mark tab as loaded when user interacts with pagination
      if (!this.loadedTabs[type]) {
        this.loadedTabs[type] = true
      }
      
      // Update pagination state immediately for responsive UI
      this.pagination[type].page = page
      if (itemsPerPage) {
        this.pagination[type].itemsPerPage = itemsPerPage
      }
      
      switch(type) {
        case 'active':
          this.loadActiveTenants(page, itemsPerPage, filters)
          break
        case 'arrears':
          this.loadArrearsTenants(page, itemsPerPage, filters)
          break
        case 'notChased':
          this.loadNotChasedTenants(page, itemsPerPage, filters)
          break
        case 'historic':
          this.loadHistoricTenants(page, itemsPerPage, filters)
          break
      }
    }
  }
}
</script>
